import { toast } from 'react-toastify';
import { getNavigate } from '../components/navigationHelper';
import { getEnvelopeRfqUlid } from './types';
import {
  OPEN_KNOTS_LIFECYCLE_TOAST_AUTO_CLOSE_MS,
  rememberOpenKnotsLifecycleToast,
} from './openKnotsBidLifecycle';

function LifecycleToastBody({ title, message }) {
  if (!title) return message;
  return (
    <div>
      <div style={{ fontWeight: 600, marginBottom: 2 }}>{title}</div>
      <div>{message}</div>
    </div>
  );
}

/**
 * Show the Open Knots bid toast immediately from a websocket envelope or notification row.
 * @param {{ level?: string, title?: string, message?: string, toastId?: string, rfqUlid?: string, dedupeKey?: string }|null} spec
 * @param {unknown} [envelope]
 */
export function showOpenKnotsLifecycleToast(spec, envelope) {
  if (!spec?.message) return;

  toast.dismiss('new-notifications');
  rememberOpenKnotsLifecycleToast(spec.dedupeKey);

  const notify = spec.level === 'success' ? toast.success : toast.info;
  const toastId = notify(<LifecycleToastBody title={spec.title} message={spec.message} />, {
    toastId: spec.toastId,
    onClick: () => {
      const navigate = getNavigate();
      const rfqUlid = spec.rfqUlid || getEnvelopeRfqUlid(envelope);
      if (rfqUlid) {
        navigate(`/RfqDetailsOpenKnots/${rfqUlid}`);
      } else {
        navigate('/notifications');
      }
      toast.dismiss(toastId);
    },
    autoClose: OPEN_KNOTS_LIFECYCLE_TOAST_AUTO_CLOSE_MS,
    style: { cursor: 'pointer' },
  });
}
